import { Topic, Post } from '../../types/forum';
import { getUserById } from '../users';

export const categoryId = '2';
export const categoryName = 'Goosifer Sightings and Tracking';
export const categoryDescription = 'Have you seen or think you\'ve seen Goosifer? Share details here!';

// Helper function to generate topic IDs within this category
const makeTopicId = (localId: number) => `${categoryId}-${localId}`;
const makePostId = (topicLocalId: number, postLocalId: number) => `${categoryId}-${topicLocalId}-${postLocalId}`;

export const topics: Topic[] = [
  {
    id: makeTopicId(1),
    title: 'Important! Read this before posting sighting and tracking details',
    categoryId: '2',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2021-08-30T09:15:00Z',
    lastPostAt: '2024-11-20T16:45:00Z',
    postCount: 1,
    viewCount: 892,
    isSticky: true,
    isAnnouncement: true
  },
  {
    id: makeTopicId(2),
    title: 'My first sighting back in 2019',
    categoryId: '2',
    authorId: '2',
    author: getUserById('2')!,
    createdAt: '2019-03-20T22:15:00Z',
    lastPostAt: '2021-04-29T03:22:00Z',
    postCount: 1,
    viewCount: 567
  },
  {
    id: makeTopicId(3),
    title: 'March 2021 Sighting - East Side of Sloan\'s Lake',
    categoryId: '2',
    authorId: '8',
    author: getUserById('8')!,
    createdAt: '2021-04-29T03:45:00Z',
    lastPostAt: '2021-04-29T03:45:00Z',
    postCount: 1,
    viewCount: 456
  },
  {
    id: makeTopicId(4),
    title: '2023 Search Party Sightings',
    categoryId: '2',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2023-09-15T20:30:00Z',
    lastPostAt: '2023-09-15T20:30:00Z',
    postCount: 1,
    viewCount: 1234
  },
  {
    id: makeTopicId(5),
    title: '2024 Search Party Sightings',
    categoryId: '2',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2024-09-18T13:40:00Z',
    lastPostAt: '2024-09-18T13:40:00Z',
    postCount: 1,
    viewCount: 1567
  },
  {
    id: makeTopicId(6),
    title: '2024 Latest Evidence',
    categoryId: '2',
    authorId: '9',
    author: getUserById('9')!,
    createdAt: '2024-08-05T04:11:00Z',
    lastPostAt: '2024-08-05T04:11:00Z',
    postCount: 1,
    viewCount: 156,
    isSticky: false
  },
  {
    id: makeTopicId(7),
    title: 'First Video of Goosifer - This is Real!',
    categoryId: '2',
    authorId: '10',
    author: getUserById('10')!,
    createdAt: '2025-03-07T12:04:00Z',
    lastPostAt: '2025-03-07T12:04:00Z',
    postCount: 1,
    viewCount: 23114,
    isSticky: false
  }
];

export const posts: Post[] = [
  // Sighting Guidelines
  {
    id: makePostId(1, 1),
    topicId: makeTopicId(1),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>IMPORTANT GUIDELINES FOR POSTING SIGHTINGS:</h2>

<p>Do you think you've seen Goosifer or found evidence that it was in the area? That's great! Please post any and all details to this forum. To help share as much information as possible in a way that will be easy to collate and look for patterns please provide your update in the following format:</p>

<h3>WHEN (use <a href="https://en.wikipedia.org/wiki/ISO_8601" target="_blank">ISO 8601 Format</a>)</h3>
<p><strong>DATE</strong> [YYYY/MM/DD]<br>
<strong>TIME</strong> [HH:MM:SS XM]</p>

<h3>WHERE</h3>
<p><strong>GENERAL LOCATION</strong> [City, State]<br>
<strong>COORDINATES</strong> (use <a href="https://en.wikipedia.org/wiki/ISO_6709" target="_blank">ISO 6709 Format</a>)</p>

<h3>DESCRIPTION</h3>
<p><strong>GENERAL</strong> (Provide a general description to the best of your recollection)<br>
<strong>HEIGHT</strong><br>
<strong>WEIGHT</strong><br>
<strong>COLOR</strong> (Fur/hair, eyes)</p>

<h3>INCLUDE ANY PHOTOS, VIDEOS, or DRAWINGS!!</h3>

<p><strong>Remember:</strong> We're trying to document and understand this creature, not create sensational stories. Be respectful of other members' experiences and no hoaxes or fake sightings - this is a serious research forum.</p>`,
    timestamp: '2021-08-30T09:15:00Z'
  },
  // 2019 Sighting
  {
    id: makePostId(2, 1),
    topicId: makeTopicId(2),
    authorId: '2',
    author: getUserById('2')!,
    content: `<p>I was walking my dog late at night near Sloan's Lake when I saw something that still gives me chills thinking about it.</p>

<h3>WHEN</h3>
<p><strong>DATE:</strong> March 20, 2019<br>
<strong>TIME:</strong> Around 10:15 PM</p>

<h3>WHERE</h3>
<p><strong>GENERAL LOCATION:</strong> Denver, CO<br>
<strong>COORDINATES:</strong> 39.7475, -105.0446 (near Sloan's Lake)</p>

<h3>DESCRIPTION</h3>
<p><strong>GENERAL:</strong> I was walking my dog when I saw a large figure standing near the water. At first I thought it was a person, but as I got closer I realized it was much larger and had a very unusual shape. It had what looked like a goose's head but the body was massive, like a bear or something even bigger.</p>

<p><strong>HEIGHT:</strong> At least 7 feet tall<br>
<strong>WEIGHT:</strong> Must have been 300+ pounds<br>
<strong>COLOR:</strong> The head was black and white like a Canada goose, the body was dark brown/black fur. The eyes were bright red and seemed to glow.</p>

<p>My dog started barking like crazy and the creature turned to look at us. Those red eyes... I'll never forget them. It didn't seem aggressive, just curious. After a few seconds it turned and walked into the trees by the lake.</p>

<p>I know this sounds crazy but I swear this is what I saw. Has anyone else seen anything like this around Sloan's Lake?</p>`,
    timestamp: '2019-03-20T22:15:00Z'
  },
  // March 2021 Sighting
  {
    id: makePostId(3, 1),
    topicId: makeTopicId(3),
    authorId: '8',
    author: getUserById('8')!,
    content: `<p>I recently came across this forum and am excited to share my latest sighting! I'm also looking forward to the next Sloan's Lake Search Party. I have been training and getting ready to complete the 10 full loops around the lake! I'm ready for this monster of a marathon!</p>

<h3>WHEN</h3>
<p><strong>DATE:</strong> Most recent sighting was in March 2021<br>
<strong>TIME:</strong> Roughly 8:30AM</p>

<h3>WHERE</h3>
<p><strong>GENERAL LOCATION:</strong> Denver, CO<br>
<strong>COORDINATES:</strong> Roughly 39.7475, -105.0446 per lookup on Google maps.</p>

<h3>DESCRIPTION</h3>
<p><strong>GENERAL:</strong> Most recently I was out running and didn't have my phone on me. I tried to draw what I saw and included that below. It honestly looks like Bigfoot but with a goose head and RED eyes. I can see why this creature is also called "Goosifer" because of those red, red eyes. Just like Blucifer's glowing eyes! This could have been none other than the Colfax Creature, the Sloan's Lake Monster. What stood out to me was that it didn't seem to be hiding at first. It was exploring, or maybe hunting on the small island off of Stuart and 21st on the East side of the lake. As soon as it noticed me though it ducked behind the nearest trees and I lost sight of it.</p>

<p><strong>HEIGHT:</strong> 7 or 8 feet<br>
<strong>WEIGHT:</strong> No clue<br>
<strong>COLOR:</strong> Red eyes. Black and white head and neck. Brown body. Just as described elsewhere.</p>

<p><img src="/images/goosiferdrawing2.png" alt="Monstermarathoner's sketch of the creature from March 2021" /></p>
<p><em>My MS paint sketch of what I saw on the east side of Sloan's Lake</em></p>`,
    timestamp: '2021-04-29T03:45:00Z'
  },
  // 2023 Search Party Sightings
  {
    id: makePostId(4, 1),
    topicId: makeTopicId(4),
    authorId: '6',
    author: getUserById('6')!,
    content: `<p>There were A LOT of sightings leading up to the capture of Goosifer during the first annual Search Party. Unfortunately, Goosifer escaped capture and we are now back on the search.</p>

<h3>WHEN</h3>
<p><strong>DATE:</strong> September 2, 2023 during the annual Search Party<br>
<strong>TIME:</strong> Approximately 1630</p>

<h3>WHERE</h3>
<p><strong>GENERAL LOCATION:</strong> Denver, CO<br>
<strong>COORDINATES:</strong> Approx 39.74488018382548, -105.04548564971768 (near the SLSP Basecamp location)</p>

<h3>DESCRIPTION</h3>
<p><strong>GENERAL:</strong> There are actually lots of photos of the creature taken during the search. What was unusual about these photos is that the creature appears to have human hands. This has not been previously reported but given how social the creature was and how easy it was to capture this may have been someone posing as Goosifer. Documenting these interactions but be cautious about believing that this may be an authentic goosifer. <a href="https://runsignup.com/Race/SLSP/Page/2023" target="_blank">https://runsignup.com/Race/SLSP/Page/2023</a></p>

<p><strong>HEIGHT:</strong> At least 6 ft tall, maybe 7?<br>
<strong>WEIGHT:</strong> No idea but must be at least 300 lbs<br>
<strong>COLOR:</strong> Black and white head, brown body. I think it had both fur and features but couldn't distinguish. Human hands (appearing Caucasian).</p>`,
    timestamp: '2023-09-15T20:30:00Z'
  },
  // 2024 Search Party Sightings
  {
    id: makePostId(5, 1),
    topicId: makeTopicId(5),
    authorId: '6',
    author: getUserById('6')!,
    content: `<p>Our second annual Search Party was another great success! We first spotted Goosifer's shadow and bright red eyes lurking about the lake throughout our dawn search around the lake.</p>

<p>After another grueling 10 hours of searching we had another successful capture!</p>

<p>There was some resistance involved<br>
But fortunately we had some help from those from a galaxy far, far, away.<br>
And ultimately the Search Party prevailed!</p>

<h3>DESCRIPTION</h3>

<p><strong>GENERAL:</strong> This was not the same Goosifer as last year. The markings were more colorful around the head. It is unknown if this is a mating pair. Last year's captured Goosifer that has been yet to be caught again.</p>

<p><strong>HEIGHT:</strong> At least 6 ft tall, maybe 7?<br>
<strong>WEIGHT:</strong> No idea but must be at least 300 lbs<br>
<strong>COLOR:</strong> Colorful shades of green for the head, black body. I think it had both fur and features but couldn't distinguish.</p>

<h3>WHEN</h3>
<p><strong>DATE:</strong> September 7, 2024 during the annual Search Party<br>
<strong>TIME:</strong> Approximately 1650</p>

<h3>WHERE</h3>
<p><strong>GENERAL LOCATION:</strong> Denver, CO<br>
<strong>COORDINATES:</strong> Approx 39.74488018382548, -105.04548564971768 (near the SLSP Basecamp location)</p>

<p>More documentation has been captured here: <a href="https://runsignup.com/Race/SLSP/Page/2024" target="_blank">https://runsignup.com/Race/SLSP/Page/2024</a></p>`,
    timestamp: '2024-09-18T13:40:00Z'
  },
  // 2024 Latest Evidence
  {
    id: makePostId(6, 1),
    topicId: makeTopicId(6),
    authorId: '9',
    author: getUserById('9')!,
    content: `<p><strong>WHEN</strong><br>
DATE: 2024/08/04<br>
TIME: 07:23:22</p>

<p><strong>WHERE</strong><br>
GENERAL LOCATION: Sloan's Lake, CO<br>
COORDINATES: 39.74783352635841, -105.04418805613938</p>

<p><strong>DESCRIPTION</strong><br>
GENERAL: The Denver Police Department has received multiple reports of an unidentified creature sighted around Sloan's Lake. Witnesses describe a large, humanoid figure with a goose-like head and a yeti-like muscular body, possessing glowing red eyes. As a result I've been doing a lot of recon and research around the lake, especially with the recent news of fish suddenly dying at the lake. The news is blaming it on <a href="https://denverite.com/2024/07/29/sloans-lake-fish-dying-algae/" target="_blank" rel="noopener noreferrer">algae</a> but I believe based on prior documentation that during Goosifer mating season there can be disturbances like this around habitats where there is potentially high Goosifer action. I didn't personally record any sightings but I interviewed dozens of people and captured the following witness accounts:</p>

<p><em>"I was walking my dog when I saw this massive figure near the water. It had a goose's head and these glowing red eyes. It stood there for a minute, then vanished into the trees. My dog was barking like crazy."</em> - Sarah Thompson, 32. July 28, 2024, at 11:45 PM near the northwest shore.</p>

<p><em>"The creature was standing near a pile of dead fish. Its eyes were so bright red, they looked like they were glowing. I tried to take a picture, but it disappeared too quickly."</em> - Mark Johnson, 47. August 2, 2024, at 5:15 AM near penny island.</p>

<p><em>"I saw it moving along the shore, almost like it was looking for something. It was huge, definitely not human, and those eyes... I've never seen anything like it before."</em> - Emily Rivera, 19. August 4, 2024, at 9:30 PM near the east end just off the running path.</p>`,
    timestamp: '2024-08-05T04:11:00Z'
  },
  // First Video of Goosifer
  {
    id: makePostId(7, 1),
    topicId: makeTopicId(7),
    authorId: '10',
    author: getUserById('10')!,
    content: `<h2>ACTUAL VIDEO OF GOOSIFER!</h2>

<p>I CAPTURED AN ACTUAL VIDEO OF GOOSIFER!!!</p>

<p>I broke my lens and fell down because I was in a hurry to capture this footage which is why it's not the best quality but it is actual footage! The first of its kind that I'm aware of!!</p>

<p><img src="/images/goosifervideo.gif" alt="Actual video footage of Goosifer" /></p>
<p><em>goosifer.net.gif (2.13 MiB) Viewed 23114 times</em></p>

<h3>WHEN</h3>
<p><strong>DATE:</strong> 2025/03/03<br>
<strong>TIME:</strong> 08:41</p>

<h3>WHERE</h3>
<p><strong>GENERAL LOCATION:</strong> Denver, CO around Sloan's Lake<br>
<strong>COORDINATES:</strong> 39.749449, -105.043349</p>

<h3>DESCRIPTION</h3>
<p><strong>GENERAL:</strong> Just look at the video! Definitely the head of a Goose and body of bigfoot. Just like all the drawings!</p>

<p><strong>HEIGHT:</strong> 6-7'<br>
<strong>WEIGHT:</strong> Guessing around 300 lbs?<br>
<strong>COLOR (Fur/hair, eyes):</strong> Brown fur, black/white head, and red eyes</p>`,
    timestamp: '2025-03-07T12:04:00Z'
  }
];